import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

const useTextAirFilter = () => {
  const { t } = useTranslation(i18nNS.common);

  const filtersMap = {
    1: {
      name: t('common:AirFilter.Nonstop'),
      nameAsItem: t('common:AirFilter.AllNonstop'),
    },
    2: {
      name: t('common:AirFilter.1Stop'),
      nameAsItem: t('common:AirFilter.All1Stopflights'),
    },
    3: {
      name: t('common:AirFilter.2Stop'),
      nameAsItem: t('common:AirFilter.All2Stopflights'),
    },
    departure: {
      name: t('common:AirFilter.Departure'),
    },
    arrival: {
      name: t('common:AirFilter.Arrival'),
    },
    stopAndVendor: {
      name: t('common:AirFilter.FilterFlights'),
    },
    departureAirport: {
      name: t('common:AirFilter.FilterDeparture'),
    },
    arrivalAirport: {
      name: t('common:AirFilter.FilterArrival'),
    },
  };

  return [filtersMap];
};

export default useTextAirFilter;
